export class DiagnosisModel{
    Id :number;
    Name:string;
    IsActive: boolean = true;
    Diagnosis:string;
    DiagnosisName: string;
    DiagnosisId: number;   
}